export default {"src":"/_next/static/media/linkedin_icon.9f3fba32.svg","height":56,"width":56};